import React from "react";
import { FaQuoteLeft } from "react-icons/fa";

function TestimonialCard({ testimonial }) {
	return (
		<div className="relative w-full lg:w-[30rem] h-full rounded-2xl ring-1 ring-indigo-300  select-none">
			<img
				src={testimonial.img}
				alt="Testimonial"
				className="absolute left-8 -top-12 w-24 h-24 rounded-full object-cover"
			/>

			<div className="absolute bottom-0 left-2 text-7xl text-mainColor/20 -z-10">
				<FaQuoteLeft />
			</div>

			{/* Optional text/content overlay on blurred background */}
			<div className="pt-14 flex items-center justify-center px-4 py-6">
				<p className="text-sm text-center text-black opacity-90">
					"{testimonial.testimonial}"
				</p>
			</div>

			{/* Card content with name and title */}
			<div className="w-full flex flex-col items-end px-6 py-3">
				<h4 className="text-lg font-semibold text-gray-800">
					{testimonial.name}
				</h4>
				<p className="text-sm text-gray-500">{testimonial.title}</p>
			</div>
		</div>
	);
}

export default TestimonialCard;
